import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { ICompany, ICompanyFilter, ICompanyWithStatsFilter } from "./companies.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class CompaniesService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getCompanies(filter?: ICompanyFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_COMPANIES)}${queryParams}`);
  }

  getCompaniesWithStats(filter?: ICompanyWithStatsFilter): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_COMPANIES)}/stats${queryParams}`);
  }

  getCompany(company: ICompany | string): Observable<any> {
    let id = (typeof company == 'string') ? company : company._id;
    return this._http.get(`${apiURL(EnvConfig.API_COMPANIES)}/${id}`);
  }

  createCompany(company: ICompany): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_COMPANIES)}`, company);
  }

  updateCompany(company: ICompany): Observable<any> {
    let id = company._id;
    delete company._id;
    return this._http.patch(`${apiURL(EnvConfig.API_COMPANIES)}/${id}`, company);
  }

  deleteCompany(company: ICompany | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof company == 'string') ? company : company._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_COMPANIES)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_COMPANIES)}/${id}/delete`);
  }

  restoreCompany(company: ICompany | string): Observable<void> {
    let id = (typeof company == 'string') ? company : company._id;
    return this._http.post(`${apiURL(EnvConfig.API_COMPANIES)}/${id}/restore`, null);
  }
}